<template>
  <div id="App">
    <div id="AppWrap">
      <b-navbar id="headernav" toggleable="lg" type="light" variant="light">
        <b-navbar-brand to="/">
          <img id="logo" :src="logo" class="d-inline-block align-top" />
        </b-navbar-brand>

        <b-navbar-toggle target="#" @click="menu = true">
          <template #default="{ expanded }">
            <md-icon
              class="menu-icon"
              v-if="expanded"
              icon="menu_open"
            ></md-icon>
            <md-icon class="menu-icon text-white" v-else icon="menu"></md-icon>
          </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav> </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item to="/operation-tracking"
              ><md-icon icon="rv_hookup" />
              {{ $t("global.operationTracking") }}</b-nav-item
            >
            <b-nav-item to="/operation"
              ><md-icon icon="taxi_alert" />
              {{ $t("global.operationAssignment") }}</b-nav-item
            >
            <b-nav-item to="/reservations"
              ><md-icon icon="directions_car" />
              {{ $t("global.bookings") }}</b-nav-item
            >
            <b-nav-item v-if="$root.userCan('users')" to="/users"
              ><md-icon icon="supervisor_account" />
              {{ $t("global.users") }}</b-nav-item
            >
            <b-nav-item
              v-if="$root.userCan('transportUnits')"
              to="/transport-units"
              ><md-icon icon="airport_shuttle" />
              {{ $t("global.transportUnits") }}</b-nav-item
            >
            <b-nav-item to="/imports"
              ><md-icon icon="upload_file" />
              {{ $t("global.import") }}</b-nav-item
            >
			<b-nav-item-dropdown>
				<template #button-content><md-icon icon="request_page"/> {{$t('global.reports')}} </template>
				<b-dropdown-item to="/"> <md-icon icon="insights" /> {{$t('global.dashboard')}}</b-dropdown-item>
				<b-dropdown-item to="/reports/rides" v-if="$root.userCan('revenue')"> <md-icon icon="directions_car"/> {{$t('reports.myRevenue')}}</b-dropdown-item>
				<b-dropdown-item to="/reports/reviews"> <md-icon icon="rate_review"/> {{$t('reports.reviews')}}</b-dropdown-item>
			</b-nav-item-dropdown>

          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <h5>
              <b-badge
                @click="changePlatform"
                v-b-tooltip.hover
                v-b-tooltip.placement.auto
                title="Cambiar"
                class="btn mt-2 ml-2 mr-4 font-weight-normal"
                variant="warning"
                >{{ system.code }}</b-badge
              >
            </h5>
            <b-avatar
              variant="primary"
              :text="user.firstName.charAt(0)"
            ></b-avatar>
            <b-nav-item-dropdown right>
              <template v-slot:button-content>
                <em>{{ user.email }}</em>
              </template>
              <b-dropdown-item to="/profile"
                ><md-icon icon="account_circle" />
                {{ $t("global.profile") }}</b-dropdown-item
              >
              <b-dropdown-divider />
              <b-dropdown-item to="#" @click="logout"
                >{{ $t("global.logout") }}
                <md-icon icon="time_to_leave" /><md-icon icon="directions_run"
              /></b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <slot></slot>
    </div>

    <b-sidebar title="Menu" shadow v-model="menu" backdrop>
      <nav class="mb-3">
        <b-nav vertical>
			<h5>
			<b-badge
				@click="changePlatform"
				v-b-tooltip.hover
				v-b-tooltip.placement.auto
				title="Cambiar"
				class="btn mt-2 ml-2 mr-4 font-weight-normal"
				variant="warning"
				>{{ system.code }}</b-badge
			>
			</h5>
			<b-nav-item to="/operation-tracking"
			><md-icon icon="rv_hookup" />
			{{ $t("global.operationTracking") }}</b-nav-item
			>
			<b-nav-item to="/operation"
			><md-icon icon="taxi_alert" />
			{{ $t("global.operationAssignment") }}</b-nav-item
			>
			<b-nav-item to="/reservations"
			><md-icon icon="directions_car" />
			{{ $t("global.bookings") }}</b-nav-item
			>
			<b-nav-item v-if="$root.userCan('users')" to="/users"
			><md-icon icon="supervisor_account" />
			{{ $t("global.users") }}</b-nav-item
			>
			<b-nav-item
			v-if="$root.userCan('transportUnits')"
			to="/transport-units"
			><md-icon icon="airport_shuttle" />
			{{ $t("global.transportUnits") }}</b-nav-item
			>
			<b-nav-item to="/imports"
			><md-icon icon="upload_file" />
			{{ $t("global.import") }}</b-nav-item
			>
			<b-nav-item-dropdown>
				<template #button-content><md-icon icon="request_page"/> {{$t('global.reports')}}</template>
				<b-dropdown-item to="/"> <md-icon icon="insights" /> {{$t('global.dashboard')}}</b-dropdown-item>
				<b-dropdown-item to="/reports/rides"> <md-icon icon="directions_car"/> {{$t('reports.myRevenue')}}</b-dropdown-item>
			</b-nav-item-dropdown>
			<b-dropdown-divider></b-dropdown-divider>
          <b-nav-item href="/profile" @click="setRoute"
            ><md-icon icon="account_circle" />
            {{ $t("global.profile") }}</b-nav-item
          >
          <b-nav-item href="#" @click="logout"
            >{{ $t("global.logout") }} <md-icon icon="time_to_leave" /><md-icon
              icon="directions_run"
          /></b-nav-item>
        </b-nav>
      </nav>
    </b-sidebar>

    <footer>
      <img :src="logo" />
    </footer>
    <b-modal
      id="warning-alert"
      size="sm"
      body-class="position-static"
      hide-header
      centered
      no-fade
    >
      {{ warningProps.message || $t("warnings.okToContinue") }}
      <template #modal-footer="{ close }">
        <b-button
          :disabled="warningProps.loading"
          @click="close()"
          type="button"
          class="float-right"
        >
          {{ $t("warnings.cancel") }}
        </b-button>
        <b-button
          :disabled="warningProps.loading"
          @click="
            (event) =>
              warningProps.okAction(event, warningProps.setLoading, close)
          "
          type="button"
          variant="primary"
          class="float-right"
        >
          <span v-if="!warningProps.loading">{{
            $t("warnings.continue")
          }}</span>
          <span v-else
            ><b-spinner small></b-spinner>
            {{ $t("warnings.processing") }}...</span
          >
        </b-button>
      </template>
    </b-modal>

    <!-- change platform -->
    <FormChangePlatform ref="modalChangePlatform" />
  </div>
</template>

<script>
import logo from "../../../assets/logo-sc-azul.png";
import FormChangePlatform from "../../helpers/FormChangePlatform";
import chatProvider from "@/components/helpers/helpers-chat";
import { getAuth, signOut } from "@/plugins/firebase";

export default {
  components: { FormChangePlatform },
  data() {
    return {
      logo,
      menu: false,
    };
  },
  methods: {
    logout() {
      this.$root.api
        .post("/auth/logout")
        .then(() => {
          this.$root.auxVars.clearResources();
          this.$root.store.clearUser();
          this.$router.push("/login");

          if (this.$root.chatStarted) {
            chatProvider.shutdown();
            this.$root.chatStarted = false;
          }

          //logout firebase
          const auth = getAuth();
          signOut(auth)
            .then(() => {
              // Sign-out successful.
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.error = true;
        });
    },
    setRoute(evt) {
      this.$root.setRouteEvt(evt);
    },
    changePlatform() {
      this.$refs["modalChangePlatform"].loadModel();
    },
  },
  computed: {
    user() {
      if (this.$root.store.state.currentUser)
        return this.$root.store.state.currentUser;
      else return "";
    },
    system() {
      if (this.$root.store.state.currentSystem)
        return this.$root.store.state.currentSystem.system;
      else return "";
    },
    warningProps() {
      return this.$root.warningProps;
    },
    alertProps() {
      return this.$root.alertProps;
    },
  },
  mounted() {},
};
</script>

<style>
html,
body {
  background: #e3e1fd;
}
.container {
  max-width: 1500px;
  margin-bottom: 20px;
}
.box {
  background: #fff;
  padding: 1.5em;
}
.material-icons {
  font-size: 130% !important;
  vertical-align: text-bottom !important;
}
.col-form-label {
  padding-bottom: 0;
}
.form-group {
  margin-bottom: 0.3rem;
}
.modal hr {
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}
.btn-group-sm > .btn,
.btn-sm {
  padding: 0.15rem 0.4rem;
}
.modal-header,
.modal-footer {
  padding: 0.5em 1em;
}
#headernav .navbar-nav .nav-link {
  color: #d1d1ed !important;
}
#headernav {
  background-color: #021d3e !important;
  margin-bottom: 20px;
  border-bottom: 2px solid #d1d1ed;
}
.container > .box {
  border: 2px solid #021d3e;
}

/* new status color */
.table-partialCancellation:hover {
  background-color: #fd9b49 !important;
}
.table-partialCancellation tbody + tbody,
.table-partialCancellation td,
.table-partialCancellation th,
.table-partialCancellation thead th {
  border-color: #db7849;
}
.table-partialCancellation,
.table-partialCancellationy > td,
.table-partialCancellation > th {
  background-color: #ffab65 !important;
}
.badge-partialCancellation {
  background-color: #fd7e14;
}
</style>

<style scoped>
#App {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}
#AppWrap {
  padding-bottom: 5rem;
}
#logo {
  max-width: 200px;
}
footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 10px;
  height: 5rem;
  background-color: #021d3e;
}
footer img {
  max-height: 100%;
}
</style>

<style>
	/* Animation property */
.__shake {
    animation: wiggle 2s linear infinite;
}
/* Keyframes */
@keyframes wiggle {
    0%,
    7% {
        transform: rotateZ(0);
    }
    15% {
        transform: rotateZ(-15deg);
    }
    20% {
        transform: rotateZ(10deg);
    }
    25% {
        transform: rotateZ(-10deg);
    }
    30% {
        transform: rotateZ(6deg);
    }
    35% {
        transform: rotateZ(-4deg);
    }
    40%,
    100% {
        transform: rotateZ(0);
    }
}
</style>
